import React from 'react';
import styled from 'styled-components';

const TeamSection = styled.section`
  padding: 80px 0;
  background-color: #fff;
`;

const SectionTitle = styled.h2`
  text-align: center;
  color: #6a1b9a;
  font-size: 36px;
  margin-bottom: 15px;
`;

const SectionSubtitle = styled.p`
  text-align: center;
  color: #666;
  font-size: 18px;
  margin-bottom: 50px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const Divider = styled.div`
  height: 4px;
  width: 80px;
  background: linear-gradient(to right, #00b8d4, #6a1b9a);
  margin: 0 auto 40px;
`;

const TeamContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const TeamMemberCard = styled.div`
  background-color: #f8f2ff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const MemberImage = styled.div`
  height: 300px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
    
    &:hover {
      transform: scale(1.05);
    }
  }
`;

const MemberInfo = styled.div`
  padding: 20px;
`;

const MemberName = styled.h3`
  color: #6a1b9a;
  font-size: 22px;
  margin: 0 0 5px;
`;

const MemberRole = styled.p`
  color: #00b8d4;
  font-size: 16px;
  margin: 0 0 15px;
`;

const MemberDescription = styled.p`
  color: #555;
  font-size: 14px;
  line-height: 1.6;
`;

const MemberCRO = styled.p`
  color: #888;
  font-size: 14px;
  margin: 15px 0 0;
  font-style: italic;
`;

const TeamMembers = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Dra. [Nome da Dentista]',
      role: 'Odontopediatra',
      description: 'Especialista em atendimento infantil, com formação em técnicas lúdicas para tornar a experiência odontológica divertida e tranquila para os pequenos pacientes.',
      cro: 'CRO-XX 00000',
      image: '/team/dentist1.jpg'
    },
    {
      id: 2,
      name: 'Dr. [Nome do Dentista]',
      role: 'Ortodontista',
      description: 'Especializado em ortodontia preventiva e interceptativa, acompanha o desenvolvimento da arcada dentária desde a primeira infância.',
      cro: 'CRO-XX 00000',
      image: '/team/dentist2.jpg'
    },
    {
      id: 3,
      name: '[Nome do Auxiliar]',
      role: 'Auxiliar de Saúde Bucal',
      description: 'Profissional dedicado ao acolhimento e preparação dos pequenos pacientes, tornando a experiência no consultório mais agradável e divertida.',
      cro: '',
      image: '/team/assistant.jpg'
    }
  ];

  return (
    <TeamSection id="nossa-equipe">
      <SectionTitle>Nossa Equipe</SectionTitle>
      <SectionSubtitle>
        Conheça Nossa Equipe de Atendimentos Odontológicos para Crianças
      </SectionSubtitle>
      <Divider />
      
      <TeamContainer>
        <TeamGrid>
          {teamMembers.map(member => (
            <TeamMemberCard key={member.id}>
              <MemberImage>
                <img src={member.image} alt={member.name} />
              </MemberImage>
              <MemberInfo>
                <MemberName>{member.name}</MemberName>
                <MemberRole>{member.role}</MemberRole>
                <MemberDescription>{member.description}</MemberDescription>
                {member.cro && <MemberCRO>{member.cro}</MemberCRO>}
              </MemberInfo>
            </TeamMemberCard>
          ))}
        </TeamGrid>
      </TeamContainer>
    </TeamSection>
  );
};

export default TeamMembers;
